import { QidCompanyDocument, QidCompanyDocumentCreate } from "server/models"
import { GET, DELETE, POST } from "client/store/utils"
import { QidCompanyDocumentList } from "./types"

export const LoadAllQidCompanyDocuments = (companyId: number) => (
    GET(`/qidCompanyDocument/all/${companyId}`)
    .then((documents: QidCompanyDocument[]) => {
        const documentList: QidCompanyDocumentList = {}
        const documentIds: number[] = []

        documents.forEach((document) => {
            documentList[document.fileId] = document
            documentIds.push(document.fileId)
        })
        return { documentList, documentIds }
    })
)

export const AddQidCompanyDocument = (
    companyId: number,
    fileId: number,
) => {
    const data: QidCompanyDocumentCreate = {
        companyId,
        fileId,
    }

    return POST(
        "/qidCompanyDocument/add",
        JSON.stringify(data),
    )
}

export const DeleteQidCompanyDocument = (
    companyId: number,
    fileId: number,
) => (
    DELETE(`/qidCompanyDocument/delete/${companyId}/${fileId}`)
    .then((removedRows: number) => removedRows)
)
